import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://my-video-server.herokuapp.com",
});

export default axiosInstance;
